import { createSelector } from 'reselect'

const getMyAccountData = state => state.myAccount

const notificationsViewSelector = createSelector(
	[ getMyAccountData ],
	myAccountData => ({
		notifications: myAccountData.notifications,
	})
)

export default notificationsViewSelector
